import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function EmbedIcon({
  className,
  style,
  active,
  ...props
}: IconProps & { active?: boolean }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <path
        d='M16 18L22 12L16 6'
        stroke={active ? "#8B33FF" : "#5E678C"}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 6L2 12L8 18'
        stroke={active ? "#8B33FF" : "#5E678C"}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.4316 4.47168L10.1716 19.805'
        stroke={active ? "#8B33FF" : "#5E678C"}
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
}
